export default __webpack_public_path__ + "static/media/P316.3.6ee2a70f.mp3";